import { Tooltip } from "@material-ui/core";
import React, { useEffect } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useDispatch, useSelector } from "react-redux";
import {
    getProductByIDSRequest
} from "../../../store/shopping/shopping.actions";
import { getCartProductList } from "../../../store/shopping/shopping.selector";
import { getLiveStream } from "../../../store/social/social.selector";
import { getImage } from "../../../store/user/user.selector";

const Product = () => {
    const dispatch = useDispatch();
    const { livestream, products } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
            products: getCartProductList(state),
        };
    });

    useEffect(() => {
        if (livestream._id) {
            dispatch(
                getProductByIDSRequest({
                    products: livestream.products.map((x) => x.id),
                })
            );
        }
    }, [livestream]);

    return (
        <div className="h-[calc(100vh_-_175px)] overflow-y-auto">
            <div className="flex items-center justify-start mx-1 mt-4 mb-6">
                <img
                    src={getImage(livestream.owner.attachments)}
                    alt=""
                    className="rounded-full w-[35px] aspect-square mr-2.5"
                />
                <div className="">
                    <h4 className="text-sm font-medium text-ebony-color capitalize">
                        {livestream.owner.fullName}
                    </h4>
                    <p className="text-[10px] text-black-50">
                        @{livestream.owner.userName}
                    </p>
                </div>
            </div>
            <div className="">
                {products &&
                    products.map((product) => {
                        return (
                            <div key={product._id} className="mb-5">
                                <div className="px-3.5 py-5 border border-black-10 rounded-md bg-white">
                                    <div className="grid grid-cols-2 gap-x-[18px]">
                                        <div className="">
                                            <ImageGallery
                                                showNav={false}
                                                showPlayButton={false}
                                                items={
                                                    product.allAttachments
                                                        .length > 0
                                                        ? product.allAttachments
                                                            .concat(
                                                                product.attachments
                                                            )
                                                            .map((x) => {
                                                                return {
                                                                    thumbnailWidth: 32,
                                                                    thumbnailHeight: 32,
                                                                    id: x._id,
                                                                    original:
                                                                        getImage(
                                                                            x
                                                                        ),
                                                                    thumbnail:
                                                                        getImage(
                                                                            x
                                                                        ),
                                                                };
                                                            })
                                                        : [
                                                            {
                                                                thumbnailWidth: 32,
                                                                thumbnailHeight: 32,
                                                                id: product
                                                                    .attachments
                                                                    ._id,
                                                                original:
                                                                    getImage(
                                                                        product.attachments
                                                                    ),
                                                                thumbnail:
                                                                    getImage(
                                                                        product.attachments
                                                                    ),
                                                            },
                                                        ]
                                                }
                                            />
                                        </div>
                                        <div className="">
                                            <h5 className="text-md text-black-50">
                                                {product.name}
                                            </h5>
                                            <p className="text-sm font-medium text-orange-color uppercase mb-1.5">
                                                {product.currency}{" "}
                                                {product.price.toFixed(2)}
                                            </p>

                                            <p className="text-sm font-medium text-black capitalize mb-[1px]">
                                                Stock Quantity:{" "}
                                                {product.warehouse.quantity}
                                            </p>
                                            <Tooltip
                                                title={product.descriptions}
                                            >
                                                <p className="text-sm font-normal text-black-50">
                                                    {
                                                        product.descriptions.length > 100
                                                            ? product.descriptions.slice(0, 100) +
                                                            "..."
                                                            : product.descriptions
                                                    }
                                                </p>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default Product;
